<template>
  <div>
    <base-header
      type="gradient-info"
      class="pb-6 pb-8 pt-5 pt-md-6"
    >
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row justify-content-center">
        <div class="col-xl-12 mb-3">
          <card shadow>
            <div slot="header" class="border-0">
              <div class="row align-items-center">
                <div class="col-1">
                  <base-button type="primary" size="sm" @click="$router.back()"
                    ><i class="ni ni-bold-left"></i
                  ></base-button>
                </div>
                <div class="col-8">
                  <h3 class="mb-0">{{ vm.name }}</h3>
                </div>
              </div>
            </div>
            <template>
              <div class="pl-lg-4">
                <div class="row">
                  <div class="mb-3 row col-sm-12 col-md-12 col-lg-4">
                    <img
                      style="max-width: 200px; max-height: 200px"
                      :src="imageData(vm.picture)"
                      alt="Image 1"
                    />
                  </div>
                  <div class="mb-3 row col-sm-12 col-md-12 col-lg-8">
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                      <span class="h3">{{
                        $t("sku")
                      }}</span
                      ><br />
                      <span>{{ vm.sku }}</span>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                      <span class="h3">{{
                        $t("name")
                      }}</span
                      ><br />
                      <span>{{ vm.name }}</span>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-4 mb-3">
                      <span class="h3">{{
                        $t("price")
                      }}</span
                      ><br />
                      <span>{{ vm.currency ? vm.currency.symbol : '' }} {{ vm.price }}</span>
                    </div>
                    <!-- <div class="col-sm-12 col-md-6 col-lg-3 mb-3">
                      <span class="h3">{{
                        $t("quantity")
                      }}</span
                      ><br />
                      <span>{{ vm.total_quantity }}</span>
                    </div> -->
                    <div class="col-sm-12 col-md-12 col-lg-12 mb-3">
                      <span class="h3">{{
                        $t("description")
                      }}</span
                      ><br />
                      <span>{{ vm.description }}</span>
                    </div>
                  </div>
                </div>
                <hr class="my-4" />
              </div>
            </template>
          </card>
          <b-row>
            <b-col md="12" class="mt-3">
              <inventory-table :item="vm" :title="$t('warehouses')"></inventory-table>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InventoryTable from "./../Tables/inventoryTable";
import { myRendeImage } from "@/directives/render-Image";
export default {
  name: "show-company",
  mixins: [myRendeImage],
  components: {
    InventoryTable,
  },
  data() {
    return {
      id: '',
      vm: {}
    };
  },
  async created() {
    this.id = this.$route.params.id
    await this.getInventoryByProduct(this.$route.params.id);
    this.vm = this.vmData
  },
  methods: {
    ...mapActions({
      getInventoryByProduct: "inventory/showInventory",
    }),
  },
  computed:{
    ...mapGetters({
      vmData : 'inventory/getInventoryProduct'
    })
  }
};
</script>

<style></style>
